// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__3GS73","inputDescription":"styles_inputDescription__34lZQ"};